import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import AboutPanel from '../components/AboutPanel';
import ContactSection from '../components/ContactSection';
import Hero from '../components/Hero';
import Proof from '../components/Proof';
import Work from '../components/Work';
import '../assets/styles/Home.scss';

function HomePage() {
  const location = useLocation();

  useEffect(() => {
    const scrollTo = (location.state as { scrollTo?: string } | null)?.scrollTo;
    if (scrollTo) {
      // Projeler API'den geldiği için hedef bölümün konumu ilk render'da kesin değil
      const timer = setTimeout(() => document.getElementById(scrollTo)?.scrollIntoView({ behavior: 'smooth' }), 300);
      return () => clearTimeout(timer);
    }
    window.scrollTo({ top: 0, left: 0 });
  }, [location.state]);

  return (
    <main>
      <Hero />
      <Proof />
      <Work />
      <AboutPanel />
      <ContactSection />
    </main>
  );
}

export default HomePage;
